// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3R7GH","title":"Header_title__1C2kR","side":"Header_side__28epD"};